<template>
    <div>
        <div v-if="!primaryCalendar" class="flex flex-col justify-center">
            <div>
                <h2 class="text-body mb-8">{{ $t('calendar.no_calendar.title') }}</h2>
                <p class="text-primary-80">{{ $t('calendar.no_calendar.description') }}</p>
            </div>
            <div
                @click="manageCalendars"
                class="my-16 trans-ease flex items-center justify-center font-semibold text-center relative
                 rounded-sm text-white cursor-pointer bg-primary hover:bg-primary-80 h-40 px-20 tracking-wider
                  flex-none text-body-sm leading-none"
            >
                <span>{{ toUpperCase($t('calendar.no_calendar.button').toString()) }}</span>
            </div>
        </div>
        <div
            v-if="primaryCalendar && (!availabilities || !availabilities.length)"
            class="flex flex-col justify-center"
        >
            <div>
                <h2 class="text-body mb-8">{{ $t('calendar.no_availabilities.title') }}</h2>
                <p class="text-primary-80">{{ $t('calendar.no_availabilities.description') }}</p>
            </div>
            <div
                @click="manageAvailabilities"
                class="my-16 trans-ease flex items-center justify-center font-semibold text-center relative rounded-sm text-white cursor-pointer bg-primary hover:bg-primary-80 h-40 px-20 tracking-wider flex-none text-body-sm leading-none"
            >
                <span>{{ toUpperCase($t('calendar.no_availabilities.button').toString()) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import User from "../../models/User";
import {toUpperCase} from "uri-js/dist/esnext/util";
import {mapState} from "pinia";
import {useRepo} from 'pinia-orm';
import {useAuthenticationStore} from '../../state/modules/authentication';

export default {
    computed: {
        ...mapState(useAuthenticationStore, ['currentUserId']),
        user() {
            return useRepo(User)
                .with('calendars')
                .with('calendar_profiles', (q) => {
                    q.with('calendars');
                })
                .find(this.currentUserId);
        },
        primaryCalendar() {
            return this.user?.primary_calendar_id;
        },
        availabilities() {
            return this.user?.availability_rules;
        },
    },
    methods: {
        toUpperCase,
        manageCalendars() {
            this.$router.push({name: 'user', hash: '#calendars'})
        },
        manageAvailabilities() {
            this.$router.push({name: 'user', hash: '#availabilities'})
        }
    }
}
</script>
